import Helper from "../../utils/Helper";
import clsx from "clsx";
import _ from "lodash"
function CustomPriceSpan({ value }) {
  let formattedValue = null;

  if (!_.isNaN(value)) {
      formattedValue = Number(value);
  }

  return (
    <span
      className={clsx({
        // "positive-number": Math.sign(value) === 1,
        // "negative-number": Math.sign(value) === -1,
      })}
    >
      {formattedValue == null ? Helper.formattedPrice(0) : Helper.formattedPrice(value)}
    </span>
  );
}

export default CustomPriceSpan;
